export function isJsonString(str: string) {
  try {
    JSON.parse(str)
  } catch (e) {
    console.error('isJsonString: invalid JSON', e)
    return false
  }
  return true
}
